/*
 * Wulf Wool — Trailhead flow
 * Pop-up (pick a scene -> email for 15% off, or Skip) -> color landing page (fit -> short/long sleeve) -> color-themed product page.
 * Also powers the Bundle & Save tier table on product pages.
 * Custom file. Loaded by snippets/trailhead-assets.liquid.
 */
(function () {
  'use strict';
  if (window.WulfTrailhead) return;

  var STORE_KEY = 'wulf_trailhead';
  var COLORS = {
    dusk: { name: 'Dusk', place: 'Moonlit pines' },
    moss: { name: 'Forrest Moss', place: 'Deep moss' },
    mist: { name: 'Sea Mist', place: 'Lake mist' }
  };

  function keyFromName(value) {
    var v = String(value || '').toLowerCase();
    if (v.indexOf('dusk') > -1) return 'dusk';
    if (v.indexOf('moss') > -1) return 'moss';
    if (v.indexOf('mist') > -1) return 'mist';
    return null;
  }

  function readState() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) s[k] = patch[k]; }
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) { /* storage blocked */ }
    return s;
  }

  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      if (data) { for (var k in data) { payload[k] = data[k]; } }
      window.dataLayer.push(payload);
    } catch (e) { /* noop */ }
  }

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  function setParams(patch) {
    try {
      var url = new URL(window.location.href);
      for (var k in patch) { if (patch[k] == null) url.searchParams.delete(k); else url.searchParams.set(k, patch[k]); }
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) { /* noop */ }
  }

  function cookieCode() {
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].trim();
      if (kv.indexOf('discount_code=') === 0) return decodeURIComponent(kv.slice(14));
    }
    return null;
  }

  /* ------------------------------------------------------------------ */
  /* Pop-up                                                              */
  /* ------------------------------------------------------------------ */
  function initPopup(root) {
    if (root.__thInit) return;
    root.__thInit = true;

    var dialog = root.querySelector('[data-th-dialog]');
    var panel = root.querySelector('[data-th-panel]');
    var tab = root.querySelector('[data-th-tab]');
    var form = root.querySelector('form');
    if (!dialog || !panel || !form) return;

    var emailInput = form.querySelector('input[type="email"]');
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    var returnInput = form.querySelector('input[name="return_to"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var baseTags = root.getAttribute('data-tags') || 'newsletter, trailhead';
    var landing = root.getAttribute('data-landing') || '/collections/all?view=trailhead';
    var code = (root.getAttribute('data-code') || '').trim();
    var delay = parseInt(root.getAttribute('data-delay') || '8', 10) * 1000;
    var scrollPct = parseInt(root.getAttribute('data-scroll') || '0', 10);
    var freqDays = parseInt(root.getAttribute('data-frequency') || '14', 10);
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var lastFocus = null;
    var opened = false;

    function setColor(key) {
      if (!COLORS[key]) return;
      root.setAttribute('data-th', key);
      var names = root.querySelectorAll('[data-th-name]');
      for (var i = 0; i < names.length; i++) names[i].textContent = COLORS[key].name;
      if (tagsInput) tagsInput.value = baseTags + ', trailhead-' + key;
      if (returnInput) {
        // Straight to the color landing page. Shopify's /discount/CODE?redirect= drops the target's query string,
        // so the landing page applies the code itself when it sees welcome=1 (see applyWelcome in initLanding).
        var target = landing + (landing.indexOf('?') > -1 ? '&' : '?') + 'color=' + key;
        returnInput.value = code ? target + '&welcome=1' : target;
      }
    }

    function setStep(step) {
      panel.setAttribute('data-step', step);
      panel.scrollTop = 0;
      window.setTimeout(function () {
        var el = step === 'email' ? emailInput : root.querySelector('[data-th-pick]');
        // Phones: focusing the email field raises the keyboard over the Unlock/Skip buttons (iOS), so let the
        // shopper tap the field; keyboard/screen-reader users get the field focused as before.
        if (step === 'email' && coarsePointer()) {
          if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
          el = panel;
        }
        if (el) el.focus({ preventScroll: true });
      }, 60);
    }

    // Scene photos (about 250 KB) carry data-src in the markup, so they are only fetched when the pop-up opens
    // or when it may still open by itself (see below). Eager, because the dialog is display:none until it opens.
    function loadImages() {
      var imgs = root.querySelectorAll('img[data-src]');
      for (var n = 0; n < imgs.length; n++) {
        imgs[n].loading = 'eager';
        imgs[n].src = imgs[n].getAttribute('data-src');
        imgs[n].removeAttribute('data-src');
      }
    }

    function open(step) {
      if (opened) return;
      loadImages();
      opened = true;
      lastFocus = document.activeElement;
      dialog.hidden = false;
      dialog.setAttribute('aria-hidden', 'false');
      document.body.classList.add('th-scroll-lock');
      if (tab) tab.hidden = true;
      setStep(step || 'pick');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { dialog.classList.add('is-open'); });
      });
      track('trailhead_popup_open');
    }

    function close(reason) {
      if (!opened) return;
      opened = false;
      // Move focus out first: aria-hidden on an ancestor of the focused element is blocked by the browser
      if (dialog.contains(document.activeElement)) {
        if (lastFocus && lastFocus.focus && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
        if (dialog.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur();
      }
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('th-scroll-lock');
      window.setTimeout(function () { dialog.hidden = true; }, 380);
      if (reason === 'skip') {
        if (tab && root.getAttribute('data-show-tab') === 'true') tab.hidden = false;
      } else if (reason !== 'submit') {
        writeState({ dismissedAt: Date.now() });
        if (tab && root.getAttribute('data-show-tab') === 'true') tab.hidden = false;
        track('trailhead_popup_dismiss');
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    var picks = root.querySelectorAll('[data-th-pick]');
    for (var i = 0; i < picks.length; i++) {
      picks[i].addEventListener('click', function (e) {
        var key = e.currentTarget.getAttribute('data-th-pick');
        setColor(key);
        writeState({ color: key });
        setStep('email');
        track('trailhead_scene_pick', { trailhead_color: key });
      });
    }

    var backs = root.querySelectorAll('[data-th-back]');
    for (var b = 0; b < backs.length; b++) backs[b].addEventListener('click', function () { setStep('pick'); });

    var closers = root.querySelectorAll('[data-th-close]');
    for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', function () { close('dismiss'); });

    // Skip: no sign-up, no code; still take them to the landing page for the scene they picked
    var skips = root.querySelectorAll('[data-th-skip]');
    for (var sk = 0; sk < skips.length; sk++) {
      skips[sk].addEventListener('click', function () {
        var key = root.getAttribute('data-th') || 'moss';
        var now = Date.now();
        writeState({ skipped: true, skippedAt: now, dismissedAt: now, color: key });
        track('trailhead_skip', { trailhead_color: key });
        close('skip');
        if (designMode) return;
        var target = landing + (landing.indexOf('?') > -1 ? '&' : '?') + 'color=' + key;
        fadeWith(window.getComputedStyle(root).getPropertyValue('--th-base').trim(), true);
        window.setTimeout(function () { window.location.href = target; }, 200);
      });
    }

    if (tab) tab.addEventListener('click', function () { open('pick'); });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close('dismiss'); return; }
      if (e.key !== 'Tab') return;
      var focusables = panel.querySelectorAll('button:not([disabled]), input:not([type="hidden"]), a[href]');
      var visible = [];
      for (var f = 0; f < focusables.length; f++) { if (focusables[f].offsetParent !== null) visible.push(focusables[f]); }
      if (!visible.length) return;
      var first = visible[0], last = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    form.addEventListener('submit', function () {
      var key = root.getAttribute('data-th') || 'moss';
      fadeWith(window.getComputedStyle(root).getPropertyValue('--th-base').trim(), false);
      writeState({ submitted: true, submittedAt: Date.now(), color: key });
      track('trailhead_signup', { trailhead_color: key });
      if (submitBtn) {
        window.setTimeout(function () {
          if (!submitBtn.getAttribute('data-label')) submitBtn.setAttribute('data-label', submitBtn.textContent);
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-loading-label') || 'One moment…';
        }, 0);
      }
    });

    setColor(root.getAttribute('data-th') || 'moss');

    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(root)) open('pick');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(root)) close('submit');
      });
      return;
    }

    if (root.querySelector('[data-th-error]')) {
      var prev = readState();
      setColor(prev.color || 'moss');
      open('email');
      return;
    }
    if (root.querySelector('[data-th-posted]')) {
      var st = readState();
      setColor(st.color || 'moss');
      if (returnInput && returnInput.value) { window.location.href = returnInput.value; return; }
    }

    var forced = param('trailhead') === 'open';
    if (forced) { open('pick'); return; }
    if (root.getAttribute('data-enabled') !== 'true') return;

    var state = readState();
    var blockedPage = root.getAttribute('data-blocked') === 'true';
    var dismissedRecently = state.dismissedAt && (Date.now() - state.dismissedAt) < freqDays * 86400000;
    var isCustomer = root.getAttribute('data-customer') === 'true';

    if (state.submitted || blockedPage || isCustomer) return;
    if (dismissedRecently) {
      if (tab && root.getAttribute('data-show-tab') === 'true') tab.hidden = false;
      return;
    }

    // It will open by itself: fetch the scene photos once the page has loaded, so they are ready by then
    if (document.readyState === 'complete') loadImages(); else window.addEventListener('load', loadImages);

    var triggered = false;
    function stillEligible() {
      // Re-read on every trigger: the page may come back from the back-forward cache after the shopper signed up
      // or dismissed the pop-up on another page (iOS swipe-back keeps the pending timer alive).
      var s = readState();
      if (s.submitted) return false;
      if (s.dismissedAt && (Date.now() - s.dismissedAt) < freqDays * 86400000) return false;
      return true;
    }
    function trigger() {
      if (triggered) return;
      triggered = true;
      window.removeEventListener('scroll', onScroll);
      if (!stillEligible()) {
        if (tab && root.getAttribute('data-show-tab') === 'true' && !readState().submitted) tab.hidden = false;
        return;
      }
      open('pick');
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) trigger();
    }
    function arm() {
      window.setTimeout(trigger, Math.max(delay, 1500));
      if (scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
    }
    // First visit: the cookie banner and the pop-up used to open on top of each other. Wait for the consent
    // choice (Shopify's customer privacy API / the consent app's cookie) before arming the delay.
    waitForConsent(arm);

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (submitBtn && submitBtn.disabled) {
        submitBtn.disabled = false;
        if (submitBtn.getAttribute('data-label')) submitBtn.textContent = submitBtn.getAttribute('data-label');
      }
      if (opened && readState().submitted) close('submit');
    });
  }

  // Resolves once the visitor has answered the cookie banner (or when there is no banner to answer).
  function waitForConsent(cb) {
    var done = false, poll = null, cap = null;
    var started = Date.now();
    var finish = function () { if (done) return; done = true; if (poll) window.clearInterval(poll); if (cap) window.clearTimeout(cap); cb(); };
    var hasCookie = function () { return /(^|;\s*)_pandectes_gdpr=/.test(document.cookie); };
    var bannerShowing = function () {
      // Pandectes renders its banner as an open <dialog> inside a 0-height shadow host, so look inside the shadow root
      var hosts = document.querySelectorAll('pandectes-cmp, #pandectes-banner, .pandectes-banner, #shopify-pc__banner');
      for (var i = 0; i < hosts.length; i++) {
        var h = hosts[i];
        if (h.getBoundingClientRect().height > 0) return true;
        var sr = h.shadowRoot;
        if (sr) {
          var d = sr.querySelector('dialog, [role="dialog"], .dialog');
          if (d && d.getBoundingClientRect().height > 0) return true;
        }
      }
      return false;
    };
    if (hasCookie()) { finish(); return; }
    document.addEventListener('visitorConsentCollected', finish);
    poll = window.setInterval(function () {
      if (hasCookie()) { finish(); return; }
      // Give the consent app a few seconds to render; if it never shows a banner (region without one, app
      // removed), there is nothing to wait for.
      if (Date.now() - started > 4000 && !bannerShowing()) finish();
    }, 500);
    cap = window.setTimeout(finish, 90000);
  }

  function coarsePointer() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  /* ------------------------------------------------------------------ */
  /* Landing page — one screen per step                                  */
  /* ------------------------------------------------------------------ */
  function initLanding(root) {
    if (root.__thInit) return;
    root.__thInit = true;

    var state = readState();
    var color = keyFromName(param('color')) || state.color || root.getAttribute('data-th') || 'moss';
    var fixedFit = root.getAttribute('data-fixed-fit');
    var fitParam = param('fit');
    var fit = fixedFit || ((fitParam === 'mens' || fitParam === 'womens') ? fitParam : null);

    // Size the section to exactly fill the screen below the site header
    function measure() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--th-top', Math.max(0, Math.round(top)) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    function toTop() { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } }

    function syncCards() {
      var cards = root.querySelectorAll('[data-th-card]');
      for (var i = 0; i < cards.length; i++) {
        var href = cards[i].getAttribute('data-href-' + color);
        if (href) cards[i].setAttribute('href', href);
      }
    }

    function setColor(key, fromUser) {
      if (!COLORS[key]) return;
      color = key;
      if (root.__thLoadBg) root.__thLoadBg(key, false);
      root.setAttribute('data-th', key);
      var chips = root.querySelectorAll('[data-th-color]');
      for (var i = 0; i < chips.length; i++) chips[i].setAttribute('aria-pressed', chips[i].getAttribute('data-th-color') === key ? 'true' : 'false');
      syncCards();
      writeState({ color: key });
      setParams({ color: key });
      if (fromUser) track('trailhead_landing_color', { trailhead_color: key });
    }

    function setFit(value, fromUser) {
      fit = value;
      root.setAttribute('data-fit', value || 'none');
      var labels = root.querySelectorAll('[data-th-fit-label]');
      for (var i = 0; i < labels.length; i++) labels[i].textContent = value === 'womens' ? 'Women’s' : 'Men’s';
      if (!fixedFit) setParams({ fit: value || null });
      if (!value) return;
      if (fixedFit) return;
      writeState({ fit: value });
      if (fromUser) {
        track('trailhead_fit', { trailhead_fit: value, trailhead_color: color });
        try {
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Trailhead fit': value === 'mens' ? "Men's" : "Women's", 'Trailhead scene': COLORS[color].name } }),
            keepalive: true
          });
        } catch (e) { /* noop */ }
      }
    }

    // The step that was clicked disappears, so move keyboard/screen-reader focus to the new step's heading
    function focusEl(sel) {
      var el = root.querySelector(sel);
      if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }

    var fitButtons = root.querySelectorAll('[data-th-fit]');
    for (var f = 0; f < fitButtons.length; f++) {
      fitButtons[f].addEventListener('click', function (e) {
        // The style step's photos are lazy while hidden; switch them to eager now so the cards don't sit grey
        var lazy = root.querySelectorAll('[data-th-shop] img[loading="lazy"]');
        for (var li = 0; li < lazy.length; li++) lazy[li].loading = 'eager';
        setFit(e.currentTarget.getAttribute('data-th-fit'), true);
        toTop();
        focusEl('[data-th-style-h]');
      });
    }
    var refit = root.querySelectorAll('[data-th-refit]');
    for (var r = 0; r < refit.length; r++) refit[r].addEventListener('click', function () { setFit(null, true); toTop(); focusEl('[data-th-fit-h]'); });

    // Color pills: real buttons (Tab, Enter/Space) with aria-pressed; arrow keys, Home and End move between them
    var chips = root.querySelectorAll('[data-th-color]');
    for (var c = 0; c < chips.length; c++) {
      chips[c].addEventListener('click', function (e) { setColor(e.currentTarget.getAttribute('data-th-color'), true); });
    }
    var pillGroups = root.querySelectorAll('[data-th-pills]');
    for (var pg = 0; pg < pillGroups.length; pg++) {
      pillGroups[pg].addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'first', End: 'last' };
        if (!Object.prototype.hasOwnProperty.call(keys, e.key)) return;
        var list = e.currentTarget.querySelectorAll('[data-th-color]');
        var i = Array.prototype.indexOf.call(list, document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var step = keys[e.key];
        var next = step === 'first' ? 0 : step === 'last' ? list.length - 1 : (i + step + list.length) % list.length;
        list[next].focus();
      });
    }

    // "Code applied" pill + discounted card prices, from the discount_code cookie Shopify sets
    function showApplied() {
      var code = cookieCode();
      var applied = root.querySelector('[data-th-applied]');
      if (!code || !applied) return;
      var codeEl = applied.querySelector('[data-th-code]');
      if (codeEl) codeEl.textContent = code.toUpperCase();
      applied.hidden = false;
      var expected = (root.getAttribute('data-code') || '').toUpperCase();
      if (!expected || expected === code.toUpperCase()) {
        var deals = root.querySelectorAll('[data-th-deal]');
        for (var d = 0; d < deals.length; d++) deals[d].hidden = false;
      }
    }

    // Arrived from the pop-up sign-up (return_to ...&welcome=1): apply the welcome code to the cart
    // (sets the discount_code cookie), then drop the flag so a reload does not re-apply it.
    // redirect=cart.js keeps the background request tiny (without it Shopify answers with the whole homepage).
    function applyWelcome() {
      var welcomeCode = (root.getAttribute('data-code') || '').trim();
      if (param('welcome') !== '1') return;
      if (!welcomeCode) { setParams({ welcome: null }); return; }
      var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var done = function () { setParams({ welcome: null }); showApplied(); };
      try {
        fetch(base + 'discount/' + encodeURIComponent(welcomeCode) + '?redirect=' + encodeURIComponent(base + 'cart.js'), { credentials: 'same-origin', keepalive: true })
          .then(function () { done(); track('trailhead_welcome_applied', { trailhead_color: color }); }, done);
      } catch (e) { done(); }
    }

    showApplied();
    setColor(color, false);
    setFit(fit, false);
    applyWelcome();
    track('trailhead_landing_view', { trailhead_color: color });
  }

  /* ------------------------------------------------------------------ */
  /* Themed product page                                                 */
  /* ------------------------------------------------------------------ */
  function initProduct(marker) {
    if (marker.__thInit) return;
    marker.__thInit = true;

    var cfgEl = marker.querySelector('script[type="application/json"]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var section = document.querySelector('.product--main');
    if (!section) return;
    var select = section.querySelector('select[name="options[' + cfg.colorOption + ']"]');
    if (!select) { section.classList.add('th-ready'); return; }

    // Scene photo behind the section: sized to the screen (it sits under a strong color overlay), and only the
    // selected color's photo loads right away (see loadRest below for the other two).
    var bgImgs = {};
    function loadBg(k) {
      var img = bgImgs[k];
      if (!img || img.__thLoaded) return;
      img.__thLoaded = true;
      if (cfg.srcsets && cfg.srcsets[k]) {
        img.sizes = '(max-width: 959px) 60vw, 100vw';
        img.srcset = cfg.srcsets[k];
      }
      img.src = cfg.images[k];
    }
    if (cfg.background) {
      section.classList.add('th-themed');
      var bg = document.createElement('div');
      bg.className = 'th-bg';
      bg.setAttribute('aria-hidden', 'true');
      ['dusk', 'moss', 'mist'].forEach(function (k) {
        if (!cfg.images || !cfg.images[k]) return;
        var img = document.createElement('img');
        img.className = 'th-bg__img';
        img.setAttribute('data-img-for', k);
        img.alt = '';
        img.decoding = 'async';
        bgImgs[k] = img;
        bg.appendChild(img);
      });
      section.insertBefore(bg, section.firstChild);
      loadBg(keyFromName(select.value));
      // The other colors' scenes: on wide screens once the page has loaded; on phones only once the shopper starts choosing
      var loadRest = function () { Object.keys(bgImgs).forEach(loadBg); };
      // Listen on the option controls only: a pointerdown on the whole section also fires for a scroll swipe,
      // which downloaded the other two scenes on nearly every phone visit.
      var controls = section.querySelectorAll('.product__color-swatches, .product__color-swatch, [data-option-buttons], select[name^="options["]');
      if (!controls.length) controls = [section];
      for (var ci = 0; ci < controls.length; ci++) {
        controls[ci].addEventListener('pointerdown', loadRest, { once: true, passive: true });
        controls[ci].addEventListener('focusin', loadRest, { once: true });
      }
      if (window.matchMedia && window.matchMedia('(min-width: 960px)').matches) {
        var later = function () { window.setTimeout(loadRest, 300); };
        if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
      }
    }

    var caption = null;
    if (cfg.caption) {
      var title = section.querySelector('.product__title');
      if (title) {
        caption = document.createElement('p');
        caption.className = 'th-caption';
        caption.setAttribute('aria-live', 'polite');
        title.parentNode.insertBefore(caption, title.nextSibling);
      }
    }

    var mediaColor = {};
    (cfg.media || []).forEach(function (m) { mediaColor[String(m.id)] = m.c || ''; });
    // Full-body front photo per color value (lowercase), from snippets/trailhead-front-media.liquid
    var fronts = cfg.front || {};
    function frontFor(value) { return String(fronts[String(value || '').toLowerCase()] || ''); }

    // Put the color's front photo first in the thumbnails and mobile photos
    function orderMedia(value) {
      var front = frontFor(value);
      var thumbs = section.querySelectorAll('.product-thumbnails__item[data-thumbnail-id]');
      for (var i = 0; i < thumbs.length; i++) thumbs[i].style.order = front && thumbs[i].getAttribute('data-thumbnail-id') === front ? '-1' : '';
      var items = section.querySelectorAll('.below-mobile [data-media-item-id]');
      for (var j = 0; j < items.length; j++) items[j].style.order = front && items[j].getAttribute('data-media-item-id') === front ? '-1' : '';
    }

    // Show the color's front photo as the main image (desktop thumbnails gallery)
    function showFront(value) {
      var front = frontFor(value);
      if (!front) return;
      var active = section.querySelector('.product-thumbnails__item-link.active');
      if (active && active.getAttribute('data-thumbnail-id') === front) return;
      var btn = section.querySelector('.product-thumbnails__item-link[data-thumbnail-id="' + front + '"]');
      if (btn) btn.click();
    }

    function filterMedia(value) {
      orderMedia(value);
      if (!cfg.filter) return;
      var v = String(value || '').toLowerCase();
      var hasAny = false;
      Object.keys(mediaColor).forEach(function (id) { if (mediaColor[id].toLowerCase() === v) hasAny = true; });
      if (!hasAny) v = null;

      function matches(id) {
        var c = (mediaColor[String(id)] || '').toLowerCase();
        return !v || !c || c === v;
      }
      var thumbs = section.querySelectorAll('.product-thumbnails__item[data-thumbnail-id]');
      for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('th-hide', !matches(thumbs[i].getAttribute('data-thumbnail-id')));
      var mobileItems = section.querySelectorAll('.below-mobile [data-media-item-id]');
      for (var j = 0; j < mobileItems.length; j++) mobileItems[j].classList.toggle('th-hide', !matches(mobileItems[j].getAttribute('data-media-item-id')));

      var active = section.querySelector('.product-thumbnails__item-link.active');
      if (active && !matches(active.getAttribute('data-thumbnail-id'))) {
        if (frontFor(value)) { showFront(value); return; }
        var firstMatch = section.querySelector('.product-thumbnails__item:not(.th-hide) [data-product-thumbnail]');
        if (firstMatch) firstMatch.click();
      }
    }

    // When the variant changes (color or size) the theme jumps to the variant's own photo (a close-up);
    // jump back to the color's front photo unless the shopper has picked a photo since.
    var lastVariant = null;
    var userPickedAt = 0;
    section.addEventListener('click', function (e) {
      if (e.isTrusted && e.target.closest && e.target.closest('[data-product-thumbnail]')) userPickedAt = Date.now();
    }, true);
    function variantId() {
      var input = section.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    }
    // For a moment after a variant change, undo the theme's switch to the variant photo before it paints
    var guardFrom = 0;
    function arm() { guardFrom = Date.now(); }
    function guarding() { return guardFrom && Date.now() - guardFrom < 1500 && userPickedAt < guardFrom; }
    var mediaBox = section.querySelector('.above-mobile .product__media');
    if (mediaBox && window.MutationObserver) {
      new MutationObserver(function () { if (guarding()) showFront(select.value); })
        .observe(mediaBox, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    function keepFront(value) {
      arm();
      var started = guardFrom;
      [0, 150, 400, 900].forEach(function (ms) {
        window.setTimeout(function () {
          if (userPickedAt > started || select.value !== value) return;
          showFront(value);
        }, ms);
      });
    }

    var lastKey = null;
    function apply() {
      var value = select.value;
      var key = keyFromName(value);
      if (key && cfg.background) { loadBg(key); section.setAttribute('data-th', key); }
      else section.removeAttribute('data-th');
      if (caption) caption.textContent = key && cfg.captions ? (cfg.captions[key] || '') : '';
      filterMedia(value);
      section.classList.add('th-ready');
      var variant = variantId();
      if (variant !== lastVariant || key !== lastKey) {
        lastVariant = variant;
        keepFront(value);
      }
      if (key && key !== lastKey) {
        if (lastKey) track('trailhead_pdp_color', { trailhead_color: key });
        lastKey = key;
        writeState({ lastViewedColor: key });
      }
    }

    select.addEventListener('change', function () { window.setTimeout(apply, 0); });
    section.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') window.setTimeout(apply, 0);
    });
    section.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-option-buttons], .product__color-swatches')) {
        arm();
        window.setTimeout(apply, 80);
        window.setTimeout(apply, 400);
      }
    });
    apply();
    window.setTimeout(apply, 600);
  }

  /* ------------------------------------------------------------------ */
  /* Bundle & Save tiers                                                 */
  /* ------------------------------------------------------------------ */
  function initBundle(root) {
    if (root.__thInit) return;
    root.__thInit = true;
    var container = root.closest('.product') || document;
    var tiers = root.querySelectorAll('[data-th-qty]');

    function qtyInput() { return container.querySelector('[data-quantity-input]'); }

    function highlight(q) {
      for (var i = 0; i < tiers.length; i++) {
        var t = parseInt(tiers[i].getAttribute('data-th-qty'), 10);
        var next = tiers[i + 1] ? parseInt(tiers[i + 1].getAttribute('data-th-qty'), 10) : Infinity;
        tiers[i].setAttribute('aria-pressed', q >= t && q < next ? 'true' : 'false');
      }
    }

    for (var i = 0; i < tiers.length; i++) {
      tiers[i].addEventListener('click', function (e) {
        var q = parseInt(e.currentTarget.getAttribute('data-th-qty'), 10);
        var input = qtyInput();
        if (input) {
          input.value = q;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var hidden = container.querySelectorAll('form [name="quantity"]');
        for (var h = 0; h < hidden.length; h++) hidden[h].value = q;
        highlight(q);
        track('bundle_tier_select', { bundle_quantity: q });
      });
    }

    container.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-quantity-input]')) highlight(parseInt(e.target.value, 10) || 1);
    });
    container.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity-input')) {
        window.setTimeout(function () { var input = qtyInput(); if (input) highlight(parseInt(input.value, 10) || 1); }, 30);
      }
    });
    var start = qtyInput();
    highlight(start ? parseInt(start.value, 10) || 1 : 1);
  }

  /* ------------------------------------------------------------------ */
  /* Quick view from product cards: keep the color's full-body front photo */
  /* ------------------------------------------------------------------ */
  function quickFront(root) {
    var map = {};
    String(root.getAttribute('data-th-fronts') || '').split(';').forEach(function (pair) {
      var i = pair.lastIndexOf('=');
      if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
    });
    var value = '';
    var selects = root.querySelectorAll('select[name^="options["]');
    for (var s = 0; s < selects.length; s++) {
      var n = selects[s].name.toLowerCase();
      if (n.indexOf('color') > -1 || n.indexOf('colour') > -1) value = String(selects[s].value).toLowerCase();
    }
    var front = map[value];
    if (!front) return;
    var items = root.querySelectorAll('.product__media [data-media-item-id]');
    for (var j = 0; j < items.length; j++) items[j].classList.toggle('hidden', items[j].getAttribute('data-media-item-id') !== front);
  }
  function watchQuick(root) {
    root.__thGuard = Date.now();
    if (root.__thObserved || !window.MutationObserver) return;
    root.__thObserved = true;
    new MutationObserver(function () { if (Date.now() - root.__thGuard < 1500) quickFront(root); })
      .observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('.quick-product[data-th-fronts]');
    if (!root || !e.target.closest('[data-option-buttons], .product__color-swatches, .product__color-swatch, .product__chip')) return;
    watchQuick(root);
    [0, 80, 400].forEach(function (ms) { window.setTimeout(function () { quickFront(root); }, ms); });
  }, true);
  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('.quick-product[data-th-fronts]');
    if (!root) return;
    watchQuick(root);
    window.setTimeout(function () { quickFront(root); }, 0);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Page transitions: the theme fades a full-screen cream overlay between */
  /* pages. Leaving a dark Trailhead page, fade through that page's color  */
  /* instead (snippets/page-transition-overlay.liquid picks it up on the   */
  /* next page), so pop-up -> landing -> product never flashes cream.      */
  /* ------------------------------------------------------------------ */
  function fadeWith(color, activate) {
    if (!color) return;
    try { window.sessionStorage.setItem('wulf_th_fade', JSON.stringify({ c: color, t: Date.now() })); } catch (e) { /* storage blocked */ }
    var overlay = document.getElementById('page-transition-overlay');
    if (!overlay) return;
    overlay.style.backgroundColor = color;
    if (activate) overlay.className = 'active';
  }
  function pageColor() {
    var el = document.querySelector('.th-landing[data-th], .product--main.th-themed[data-th]');
    return el ? window.getComputedStyle(el).getPropertyValue('--th-base').trim() : '';
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.getAttribute('href').charAt(0) === '#') return;
    fadeWith(pageColor(), false);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Bag drawer: keep the footer summary (Bundle & Save nudge, discount   */
  /* lines, subtotal) current. The theme's drawer refresh swaps the items  */
  /* and the subtotal figure but never adds or removes the cart-level      */
  /* discount line, so it went stale after +/-. When the drawer changes,   */
  /* re-render [data-th-cart-summary] from the section HTML. A 422 from    */
  /* add/change (quantity above stock) still changes the bag, so after     */
  /* any cart request the drawer and header count are reconciled too.     */
  /* ------------------------------------------------------------------ */
  function watchNudge() {
    var drawer = document.querySelector('.quick-cart');
    var section = drawer && drawer.closest('.shopify-section');
    if (!section || !window.MutationObserver || !window.DOMParser || !window.fetch) return;
    var sectionId = section.id.replace('shopify-section-', '');
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    function key() {
      var sub = drawer.querySelector('.quick-cart__footer-subtotal');
      var count = drawer.querySelector('.quick-cart__heading sup');
      return (sub ? sub.textContent : '') + '|' + (count ? count.textContent : '');
    }
    function drawerCount() {
      var sup = drawer.querySelector('.quick-cart__heading sup');
      return sup ? parseInt(sup.textContent, 10) || 0 : 0;
    }
    function setHeaderCount(n) {
      var els = document.querySelectorAll('[data-js-cart-count], [data-cart-count], .header__cart-count, .cart-count');
      for (var i = 0; i < els.length; i++) els[i].textContent = String(n);
    }
    function fetchSection() {
      return fetch(base + 'cart?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function swap(doc, selector) {
      var fresh = doc.querySelector(selector);
      var current = drawer.querySelector(selector);
      if (fresh && current) current.replaceWith(document.importNode(fresh, true));
      return !!(fresh && current);
    }
    var last = key();
    var timer = null;
    var busy = false;
    function sync(full) {
      timer = null;
      var now = key();
      if (!full && now === last) return;
      last = now;
      if (busy) return;
      busy = true;
      fetchSection()
        .then(function (doc) {
          if (full) {
            // Whole drawer: items, count and summary (used after a partial-success 422)
            swap(doc, '.quick-cart__items');
            var freshH = doc.querySelector('.quick-cart__heading'), curH = drawer.querySelector('.quick-cart__heading');
            if (freshH && curH) curH.innerHTML = freshH.innerHTML;
            if (!swap(doc, '.quick-cart__form')) swap(doc, '.quick-cart__container');
          }
          if (!swap(doc, '[data-th-cart-summary]')) swap(doc, '[data-bundle-nudge]');
          last = key();
        })
        .catch(function () { /* keep the current drawer */ })
        .then(function () { busy = false; });
    }
    new MutationObserver(function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () { sync(false); }, 60);
    }).observe(drawer, { childList: true, subtree: true, characterData: true });

    // Reconcile after any cart request: Shopify answers 422 to add/change when the quantity exceeds stock but
    // still applies the part it could, and the theme leaves the drawer and header count untouched in that case.
    function reconcile() {
      fetch(base + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (typeof cart.item_count !== 'number') return;
          if (cart.item_count !== drawerCount()) {
            setHeaderCount(cart.item_count);
            sync(true);
          }
        })
        .catch(function () { /* noop */ });
    }
    if (window.fetch && !window.fetch.__thWrapped) {
      var nativeFetch = window.fetch;
      var wrapped = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = nativeFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
          p.then(function (res) { if (res && (res.status === 422 || res.status >= 400)) window.setTimeout(reconcile, 250); }, function () { /* noop */ });
        }
        return p;
      };
      wrapped.__thWrapped = true;
      window.fetch = wrapped;
    }
  }

  /* ------------------------------------------------------------------ */
  function initAll(scope) {
    var s = scope || document;
    var list, i;
    list = s.querySelectorAll('[data-th-popup]'); for (i = 0; i < list.length; i++) initPopup(list[i]);
    list = s.querySelectorAll('[data-th-landing]'); for (i = 0; i < list.length; i++) initLanding(list[i]);
    list = s.querySelectorAll('[data-th-pdp]'); for (i = 0; i < list.length; i++) initProduct(list[i]);
    list = s.querySelectorAll('[data-th-bundle]'); for (i = 0; i < list.length; i++) initBundle(list[i]);
  }

  window.WulfTrailhead = { init: initAll, state: readState, reset: function () { try { window.localStorage.removeItem(STORE_KEY); } catch (e) { /* noop */ } } };

  function boot() { initAll(); watchNudge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();